import { AppRoutes } from 'strapi/types';

export const isPageLocalized = (pageSlug: string, languageList): boolean => {
  if (
    pageSlug &&
    (pageSlug.split('/')[0] === AppRoutes.BRANDS ||
      pageSlug === AppRoutes.APPS ||
      pageSlug === AppRoutes.NOT_FOUND ||
      pageSlug === AppRoutes.DRAFT)
  ) {
    return false;
  }
  return languageList ? Object.keys(languageList).length > 1 : null;
};
